import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input, Select, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { AddressType } from "../../../__generated__/globalTypes";
import { addressTypeLabel } from "../../../helpers/enum-labels";

interface ICustomerAddressForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const CustomerAddressForm: React.FC<ICustomerAddressForm> = ({
  loading,
  form,
  submit,
}) => {
  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Select label="Type" className="w-full" {...form.register("type", { required: true })}>
          <option value="">-</option>
          {Object.keys(AddressType).map((type) => (
            <option key={type} value={type}>
              {addressTypeLabel(type)}
            </option>
          ))}
        </Select>
        <Input
          label="Libellé"
          className="w-full"
          {...form.register("label", { required: "Libellé requis" })}
          placeholder="Entrepôt principal"
        />
        <Input
          label="Numéro de rue"
          className="w-full"
          {...form.register("streetNumber", { required: true })}
        />
        <Input
          label="Rue"
          className="w-full"
          {...form.register("street", { required: "Rue requise" })}
        />
        <Input
          label="Code postal"
          className="w-full"
          {...form.register("postal", { required: "Code postal requis" })}
        />
        <Input
          label="Ville"
          className="w-full"
          {...form.register("city", { required: "Ville requise" })}
        />
        <Input
          label="Latitude"
          type="number"
          step="any"
          className="w-full"
          {...form.register("lat", { required: true, valueAsNumber: true })}
        />
        <Input
          label="Longitude"
          type="number"
          step="any"
          className="w-full"
          {...form.register("lng", { required: true, valueAsNumber: true })}
        />
        <Input label="Siret" className="w-full" {...form.register("siret")} />
        <Textarea
          label="Notes de livraison"
          className="w-full"
          {...form.register("deliveryNotes")}
        />
        <label className="w-full flex items-center gap-2">
          <input type="checkbox" {...form.register("isMain")} />
          <span className="text-sm">Adresse principale</span>
        </label>
        <label className="w-full flex items-center gap-2">
          <input type="checkbox" {...form.register("active")} defaultChecked />
          <span className="text-sm">Active</span>
        </label>
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
